import { useAuthStore } from './authStore'

export const useUserPrintingAppStore = defineStore('userPrintingApp', () => {
  const { $api } = useNuxtApp()
  const user = useAuthStore()

  async function networkPrint(game: Game) {
    window.Echo.join(`user.${user.user?.id}`)
      .whisper('print-game', {
        board: game.board?.name ?? 'No board',
        round: game.round_label,
        name: game.label,
        player1: game.player1?.name ?? 'TBD',
        player2: game.player2?.name ?? 'TBD',
        writer: game.writer?.name ?? 'TBD',
        legs: game.best_of,
        track_180: game.track_one_eighties ?? false,
        track_171: game.track_one_seven_ones ?? false,
        track_high_checkout: game.track_high_checkouts ?? false,
      })
  }

  function directPrint(tournamentId: number | null, game: Game | null, group: number | null = null, group_individual: boolean = false) {
    if (null === tournamentId) {
      return
    }

    if (user.isPrinterConnected && game) {
      networkPrint(game!)
      return
    }

    $api('/tournaments/{tournament}/print', {
      method: 'post',
      path: {
        tournament: tournamentId,
      },
      body: {
        game_id: game?.id,
        group_number: group,
        group_individual: group_individual,
      },
    }).then((data) => {
      const winPrint = window.open('', '', 'left=0,top=0,width=800,height=auto,toolbar=0,scrollbars=0,status=0')
      if (!winPrint) {
        return
      }
      winPrint.document.write(atob(data.html))
      winPrint.document.close()
      winPrint.focus()
      winPrint.addEventListener('load', function () {
        winPrint.print()
        winPrint.close()
      })

      if (game) {
        game.printed = true
      }
    })
  }

  return { directPrint }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserPrintingAppStore, import.meta.hot))
}
